import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Button } from '@mui/material';
import { Facebook, Instagram, Twitter, Phone, Email, LocationOn, AccessTime } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useVacation } from '../context/VacationContext';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const vacationMode = useVacation();

  return (
    <Box component="footer" className="footer">
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Box className="footer-section">
              <Typography variant="h5" className="footer-title" gutterBottom>
                Noureddine
              </Typography>
              <Typography variant="body1" className="footer-description">
                Experience the art of grooming at its finest. Our skilled barbers combine traditional 
                techniques with modern style to give you the perfect look.
              </Typography>
              <Box className="social-icons">
                <IconButton color="inherit" aria-label="Facebook" component="a" href="#" className="social-icon">
                  <Facebook />
                </IconButton>
                <IconButton color="inherit" aria-label="Instagram" component="a" href="#" className="social-icon">
                  <Instagram />
                </IconButton>
                <IconButton color="inherit" aria-label="Twitter" component="a" href="#" className="social-icon">
                  <Twitter />
                </IconButton>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Box className="footer-section">
              <Typography variant="h6" className="footer-title" gutterBottom>
                Contact Information
              </Typography>
              <Box className="contact-info">
                <Box display="flex" alignItems="center" mb={2}>
                  <LocationOn className="contact-icon" />
                  <Typography variant="body1">
                    48 Revere Street<br />
                    Revere, MA 02151
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={2}>
                  <Phone className="contact-icon" />
                  <Typography variant="body1" component="a" href="tel:+11234567890" className="contact-link">
                    (857) 312-1374 
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={2}>
                  <Email className="contact-icon" />
                  <Typography variant="body1" component="a" href="mailto:info@noureddinebarbershop.com" className="contact-link">
                  info@nouredinestyle.com
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Box className="footer-section">
              <Typography variant="h6" className="footer-title" gutterBottom>
                Opening Hours
              </Typography>
              <Box className="hours-info">
                <Box display="flex" alignItems="center" mb={2}>
                  <AccessTime className="contact-icon" />
                  <Box ml={2}>
                    <Typography variant="body1" component="div">
                      Monday - Thursday: 11am - 8pm<br />
                      Friday: Closed<br />
                      Saturday: 11am - 8pm<br />
                      Sunday: 11am - 8pm
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {vacationMode ? (
                <Typography variant="body2" color="error" sx={{ mt: 2, mb: 2 }}>
                  On vacation from {vacationMode.startDate.toLocaleDateString()} to {vacationMode.endDate.toLocaleDateString()}
                </Typography>
              ) : null}
              <Button 
                variant="contained" 
                color="primary" 
                className="book-button" 
                component={Link}
                to="/appointment"
              >
                Book Appointment
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Box className="footer-bottom">
          <Typography variant="body2" color="text.secondary" align="center">
            {currentYear} Noureddine Barbershop. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
